<template>
  <div>
    <section id="cloud">
      <div class="box pr">
        <!-- 登录 -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0"
          class="form_box"
        >
          <el-form-item prop="userName">
            <el-input
              size="medium"
              v-model="ruleForm.userName"
              placeholder="域账号/手机号"
              maxlength="50"
              :clearable="true"
              v-on:keyup.enter.native="submitForm"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pass" class="pr" style="margin-bottom:0">
            <el-input
              size="medium"
              v-model="ruleForm.pass"
              :type="passwordState ? 'text' : 'password'"
              placeholder="密码"
              v-on:keyup.enter.native="submitForm"
            ></el-input>
            <img
              class="eys"
              v-if="passwordState"
              @click="passwordState = !passwordState"
              src="@/assets/images/eys-show.png"
              alt
            />
            <img
              class="eys"
              v-else
              @click="passwordState = !passwordState"
              src="@/assets/images/eys-hidden.png"
              alt
            />
          </el-form-item>
          <div class="sigh" style="height:10px; margin-top:25px">
            <p style="color:#ec4452;margin-left:10px" v-if="errorText != ''">
              {{ errorText }}
            </p>
          </div>
          <el-form-item class="mt-20">
            <el-button size="medium" class="button" @click="submitForm"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import { setCookie, getUrlParams } from '@/uitls/index.js'
import aes from '@/uitls/aes'
export default {
  data() {
    return {
      // 错误提示
      errorText: '',
      // 密码是否明文显示
      passwordState: false,
      // 表单内容
      ruleForm: {
        userName: '',
        pass: ''
      },
      rules: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      // 获取验证码按钮是否可点击
      isVerifyCode: true,
      codeValueReg: '获取验证码'
    }
  },
  methods: {
    oepn() {
      // window.location.href = 'http://asd.vanke.com:8080/#/login'
      // window.open('http://asd.vanke.com:8080/#/login')
    },
    // 提交表单
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let data = {}
          data.type = 'login'
          this.$http
            .post('/user-server/user/pc_login.do', {
              userAccount: this.ruleForm.userName,
              loginType: 1,
              password: aes.Encrypt(this.ruleForm.pass)
            })
            .then(res => {
              data.response = res
              if (res.data.code == 200) {
                this.errorText = ''
                // 如果选择了记住账号密码, 点击登录返回成功之后设置cookie
                let name = this.ruleForm.userName
                let pass = this.ruleForm.pass
                // 如果登录成功了设置.vanke.com同域的cookie
                setCookie('accesstoken', res.data.value, 1)
              } else if (res.data.code == 10011) {
                // TODO: unify login logic
                this.errorText = ''
                let name = this.ruleForm.userName
                let pass = this.ruleForm.pass
                res.data.code = 200
                setCookie('accesstoken', res.data.value, 1)
              } else {
                this.errorText = res.data.message
              }
              window.parent.postMessage(JSON.stringify(data), '*')
            })
            .catch(err => {
              data.response = err
              window.parent.postMessage(JSON.stringify(data), '*')
              console.log(err)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#cloud {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 100%;
    background-color: #ffffff;
    border-radius: 6px;
    .form_box {
      margin: 0 50px;
      .eys {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
      }
      .sigh {
        & > p {
          position: relative;
          padding-left: 20px;
          &::after {
            content: '!';
            position: absolute;
            left: 0;
            top: 2px;
            width: 16px;
            height: 16px;
            background-color: #ec4452;
            border-radius: 50%;
            text-align: center;
            line-height: 16px;
            color: #fff;
          }
        }
      }
      .button {
        color: #fff;
        width: 100%;
        background-color: #ec4452;
        background: #ec4452;
        border-color: #ec4452;
        border-radius: 4px;
        &:hover {
          background-color: #f17d86;
          border-color: #f17d86;
        }
        &:active {
          background-color: #db2637;
          border-color: #db2637;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cloudStructure/components/login.vue